import { APICall } from "@/config/NetworkUtility";
import { logApiError } from "@/services/apiErrorLogger";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getRolesList = createAsyncThunk(
  "roles/getRolesList",
  async (_, { rejectWithValue }) => {
    try {
      const url = "/v1/Common/GetRoleList";

      const result = await APICall("get", {}, url);

      const isSuccess = [200, 201].includes(result?.statuscode);

      if (!isSuccess) {
        return rejectWithValue({
          message: result?.message || "Failed to fetch roles",
          statuscode: result?.statuscode,
          data: result?.data || null,
        });
      }

      return result?.data ?? [];
    } catch (error) {
      logApiError(error, {
        source: "roles",
        endpoint: "getRolesList",
      });

      return rejectWithValue({
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong",
        statuscode: error?.response?.status || 500,
      });
    }
  },
);

const initialState = {
  roleList: [],
  loading: false,
  error: null,
};

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRolesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRolesList.fulfilled, (state, action) => {
        state.loading = false;
        state.roleList = action.payload;
      })
      .addCase(getRolesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default rolesSlice.reducer;
